export const securityRoleIds = {
  admin: "3b0c0906-b7ae-4392-aec5-a71df6c7c631",
  providerSwiftCode: "61e009f7-0cb0-4804-8833-c38f1ac886c5",
  remoteProvider: "f0a70f42-418b-4e38-8735-5d6e27174155",
  supplier: "22948e62-4c5e-45bf-b134-6329380b1883"
};
